// extracted by mini-css-extract-plugin
module.exports = {"nombreEtage":"NombreEtage_nombreEtage__1FFCh","btn":"NombreEtage_btn__KFLBn","disabled":"NombreEtage_disabled__2lvrJ","inputValue":"NombreEtage_inputValue__1hzET"};